module.exports = __webpack_public_path__ + "aae4752d9340a76a92d230201aa3ef38.svg";